import * as yup from 'yup';
import { Language } from '../../../CommonSelectors/CommonArea.types';

export interface FormValues {
  languagePreference: Language | null;
}

export const FORM_SCHEMA = yup.object().shape({
  languagePreference: yup
    .number()
    .nullable()
    .required('Please select a default language'),
});
